import {
  USERS_LIST_URL,
  CATEGORY_LIST_URL,
  GENERAL_SETTING_GET_URL,
} from "../utils/Constant";
const moment = require("moment-timezone");

const fetchData = async (url, token) => {
  // const authToken = useSelector(state => state.token);
  //console.log("authToken", token.token)
  // const authToken = await loginUser();
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token.token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const responseData = await response.json();

    return responseData; // Return the data
  } catch (error) {
    console.error("API Error:", error.message);
    throw error; // Re-throw the error
  }
};

const usersList = async (token) => {
  return fetchData(USERS_LIST_URL, token);
};

const categoryList = async (token) => {
  return fetchData(CATEGORY_LIST_URL, token);
};

const generalSettingData = async (token) => {
  return fetchData(GENERAL_SETTING_GET_URL, token);
};

// Date Formatter functions

function formatDate(inputDate) {
  const date = new Date(inputDate);

  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "short" });
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";

  const formattedDate = `${ordinalSuffix(day)} ${month}, ${year} ${
    hours % 12 || 12
  }:${padWithZero(minutes)} ${ampm}`;

  return formattedDate;
}

function ordinalSuffix(number) {
  const suffixes = ["th", "st", "nd", "rd"];
  const v = number % 100;
  return number + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
}

function padWithZero(number) {
  return number.toString().padStart(2, "0");
}

function amountToWords(amount) {
  // Define arrays for one-digit and two-digit numbers in words
  const ones = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
  ];
  const teens = [
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const tens = [
    "",
    "Ten",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  // Function to convert a number less than 1000 to words
  function convertLessThanThousand(number) {
    if (number === 0) {
      return "";
    } else if (number < 10) {
      return ones[number];
    } else if (number < 20) {
      return teens[number - 11];
    } else if (number < 100) {
      return `${tens[Math.floor(number / 10)]} ${convertLessThanThousand(
        number % 10
      )}`;
    } else {
      return `${
        ones[Math.floor(number / 100)]
      } Hundred ${convertLessThanThousand(number % 100)}`;
    }
  }

  // Function to convert a number to words
  function convertNumberToWords(number) {
    if (number === 0) {
      return "Zero";
    } else {
      const billion = Math.floor(number / 1000000000);
      const million = Math.floor((number % 1000000000) / 1000000);
      const thousand = Math.floor((number % 1000000) / 1000);
      const remainder = number % 1000;

      let result = "";

      if (billion > 0) {
        result += `${convertLessThanThousand(billion)} Billion `;
      }

      if (million > 0) {
        result += `${convertLessThanThousand(million)} Million `;
      }

      if (thousand > 0) {
        result += `${convertLessThanThousand(thousand)} Thousand `;
      }

      if (remainder > 0) {
        result += convertLessThanThousand(remainder);
      }

      return result.trim();
    }
  }

  // Format the amount to have two decimal places
  const formattedAmount = Number(amount).toFixed(2);
  // Split the amount into dollars and cents
  const [dollars, cents] = formattedAmount.split(".");
  // Convert dollars and cents to words
  const dollarsInWords = convertNumberToWords(parseInt(dollars, 10));
  const centsInWords =
    cents !== "00"
      ? ` and ${convertNumberToWords(parseInt(cents, 10))} Cents`
      : "";

  // Construct the final result
  let result = dollarsInWords ? `${dollarsInWords} Dollars` : "";
  result += centsInWords;

  return result || "Zero Dollars";
}

function convertIsoToCustomFormat(isoDate) {
  // Parse the UTC date string
  const utcMoment = moment.utc(isoDate);

  // Convert to the local time zone
  const localMoment = utcMoment.local();

  // Format the local date and time
  const localFormatted = localMoment.format('MMMM Do YYYY, h:mm:ss A');

  return localFormatted;
}

function getProductTimeZone() {
  const date = new Date(); // Get the current date/time
  const options = { timeZoneName: 'short' }; // Specify to get the short name of the time zone
  const productTimeZone = Intl.DateTimeFormat(undefined, options).resolvedOptions().timeZone;
  return productTimeZone;
}

// Example usage
const productTimeZone = getProductTimeZone();


function convertIsoToLocalFormat(isoDate) {
  console.log("productTimeZone>>>>>>>>>>",productTimeZone)
  let localFormatted = moment(isoDate).tz(productTimeZone).format('YYYY-MM-DDTHH:mm');
  return localFormatted;
}
export {
  usersList,
  categoryList,
  generalSettingData,
  formatDate,
  amountToWords,
  convertIsoToCustomFormat,
  convertIsoToLocalFormat,
};

// function convertIsoToCustomFormat(isoDate) {
//     const options = {
//         year: "numeric",
//         month: "long",
//         day: "numeric",
//         hour: "numeric",
//         minute: "numeric",
//         hour12: true,
//     };

//     const dateObject = new Date(isoDate);
//     const month = dateObject.toLocaleString("en-US", { month: "long" });
//     const day = dateObject.getDate();
//     const year = dateObject.getFullYear();
//     const hours = dateObject.getUTCHours();
//     const minutes = dateObject.getUTCMinutes();

//     const period = hours >= 12 ? "PM" : "AM";
//     const formattedDate = `${month} ${day}, ${year} at ${hours}:${minutes} ${period}`;

//     return formattedDate;
// }
